export interface DhChatMedia {
    src: string
    mimeType: string
    originalName?: string
}

const IMAGE_EXT = /\.(png|jpe?g|gif|webp|bmp|svg)(\?|#|$)/i
const VIDEO_EXT = /\.(mp4|webm|mov|m4v)(\?|#|$)/i

export function coerceDhChatMedia(raw: unknown): DhChatMedia | null {
    if (!raw || typeof raw !== 'object') return null
    const item = raw as Record<string, unknown>
    const src =
        (typeof item.src === 'string' && item.src) ||
        (typeof item.url === 'string' && item.url) ||
        ''
    if (!src) return null
    const mimeType =
        (typeof item.mimeType === 'string' && item.mimeType) ||
        (typeof item.mime === 'string' && item.mime) ||
        ''
    const originalName =
        (typeof item.originalName === 'string' && item.originalName) ||
        (typeof item.name === 'string' && item.name) ||
        undefined
    return { src, mimeType, originalName }
}

export function mediaFromMessagePayload(raw: { media?: unknown; data?: unknown }): DhChatMedia | null {
    const direct = coerceDhChatMedia(raw.media)
    if (direct) return direct
    const data = raw.data
    if (data && typeof data === 'object' && 'media' in data) {
        return coerceDhChatMedia((data as { media?: unknown }).media)
    }
    return null
}

export function isImageMedia(media?: DhChatMedia | null): boolean {
    if (!media) return false
    if (media.mimeType.startsWith('image/')) return true
    return IMAGE_EXT.test(media.originalName || '') || IMAGE_EXT.test(media.src)
}

export function isVideoMedia(media?: DhChatMedia | null): boolean {
    if (!media) return false
    if (media.mimeType.startsWith('video/')) return true
    return VIDEO_EXT.test(`${media.originalName || ''} ${media.src}`)
}

export function normalizeUploadedMedia(url: unknown, file: File): DhChatMedia | null {
    if (url && typeof url === 'object') {
        const fromObject = coerceDhChatMedia(url)
        if (fromObject) {
            return {
                ...fromObject,
                mimeType: fromObject.mimeType || file.type,
                originalName: fromObject.originalName || file.name,
            }
        }
        if ('url' in url) return normalizeUploadedMedia((url as { url?: unknown }).url, file)
    }
    if (typeof url === 'string' && url) {
        return { src: url, mimeType: file.type, originalName: file.name }
    }
    return null
}

export function mediaChipName(media?: DhChatMedia | null): string {
    if (media?.originalName) return media.originalName
    if (isVideoMedia(media)) return 'Видео'
    if (isImageMedia(media)) return 'Изображение'
    return 'Файл'
}
